module.exports = {"431271001":"河滨路街道","431271002":"沅江路街道","431271003":"新街街道","431271004":"高坡街街道","431271218":"横岩乡","431271220":"桂花园乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431271.json
// module id = 1928
// module chunks = 0